import ChatHistory from "./chatHistory";

export default ChatHistory;
